export class State {
    setMachineAndContext(machine, context) {
        this._machine = machine;
        this._context = context;
        this.onInitialized();
    }
    /**
     * 在设置machine和context之后直接调用，允许状态执行任何所需的设置
     *
     * @memberof State
     */
    onInitialized() { }
    /**
     * 当状态变为活动状态时调用
     *
     * @memberof State
     */
    begin() { }
    /**
     * 在更新之前调用，允许状态最后一次机会改变状态
     *
     * @memberof State
     */
    reason() { }
    /**
     * 此状态不再是活动状态时调用
     *
     * @memberof State
     */
    end() { }
}
//# sourceMappingURL=State.js.map